import * as React from 'react'

const SvgBrowserSpellcheckIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={17} height={17} viewBox="0 0 17 17" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5 11.75h1.25l-3.125-7.5h-1.25l-3.125 7.5H5.5l.775-1.875h3.456l.769 1.875zM6.794 8.625L7.93 5.862h.157L9.25 8.625H6.794zM5.5 15.5H1.75c-.69 0-1.25-.56-1.25-1.25V1.75C.5 1.06 1.06.5 1.75.5h12.5c.69 0 1.25.56 1.25 1.25v6.875h-1.25V1.75H1.75v12.5H5.5v1.25zm6.875-.512l-1.619-1.62-.881.882 2.5 2.5 4.375-4.375-.881-.881-3.494 3.494z"
      fill="#163250"
    />
  </svg>
)

export default SvgBrowserSpellcheckIcon
